/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BlockedTime/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BlockedTimeDialog from './BlockedTimeDialog/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BlockedTime({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/BlockedTime",
  triggerRef,
  onMouseEnterTrigger,
  onMouseMoveTrigger,
  onMouseLeave,
  hovered,
  top,
  left,
  contentRef,
  onMouseEnterContent
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="BlockedTime.Vertical"
  data-view-path={viewPath}
 ref={triggerRef}
 onMouseEnter={onMouseEnterTrigger}
 onMouseMove={onMouseMoveTrigger}
 onMouseLeave={onMouseLeave}
 style={{'--bblr-1-Z1sJrAm': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-2-Z1sJrAm': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-3-Z1sJrAm': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-4-Z1sJrAm': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-6-Z1sJrAm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-Z1sJrAm': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-8-Z1sJrAm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-Z1sJrAm': hovered ? "#CBD2D9" : "#CBD2D9"}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Blocked Time"
 weight="regular"
 size="small"
 color="#323F4B"
/>
</div>
<BlockedTimeDialog
  viewPath={`${viewPath}/BlockedTimeDialog`}
 top={top}
 left={left}
 isOpen={hovered}
 contentRef={contentRef}
 onMouseEnter={onMouseEnterContent}
 onMouseLeave={onMouseLeave}
/>
{children}
</React.Fragment>)
}